var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      withoutLoading: "",
      placeholder: "Select country",
      value: _vm.value,
      multiple: _vm.multiple,
      options: _vm.options,
      searchable: _vm.searchable,
      groupLabel: _vm.groupLabelName,
      groupValues: _vm.groupValuesName,
      disabled: _vm.disabled,
      noOptionsText: "Please, choose a country first",
    },
    on: { search: _vm.handleSearch, input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }